<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions,mapState } from "vuex";

/**
 * Invoice-detail component
 */
export default {
  page: {
    title: "Insurance Invoice Detail",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      model_id:"",
      title: "Insurance Invoice Detail",
      edit_invoice:{ 
        id:"",
       type:"",
       service: "",
        serv_date: "", 
        cost: "" ,
        invoice_id:this.$route.params.invoice_id,
        visit_id:""
        }
    };
  },
  computed: {
      ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("insurance", ["InsuranceCompanyInvoice", "InsuranceInvoiceStatus"]),
    ...mapGetters("payments", ["PaymentModes"]),
  },
    watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeMode(this.model_id);
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.submitted = false;
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchCompany_Invoice: "insurance/fetchCompany_Invoice",
      Edit_Insurance_Invoice: "insurance/edit_Insurance_Invoice",
      FetchPaymentModes: "payments/fetchPaymentModes",
    }),
    setEditAmount(data,model){
      this.model_id =model
    this.edit_invoice = { 
        id:data.id,
       type:data.type,
       service: data.service,
        serv_date:data.serv_date, 
        cost:data.cost,
        lab_complete:data.lab_complete,
        invoice_id:this.$route.params.invoice_id,
        }
    },
    editInvoiceAmount(){
this.Edit_Insurance_Invoice(this.edit_invoice)
    },
      closeMode(model_id) {
      this.$nextTick(() => {
        this.$bvModal.hide(model_id);
      });
    },
  },
  beforeCreate() {
    this.$store.commit("insurance/SET_INSURANCE_INVOICE_TEMPLATE");
  },
  created() {
    this.FetchCompany_Invoice(this.$route.params.invoice_id);
    this.FetchPaymentModes();
  },
};
</script>
<style scoped>
tr, td {
  padding-top: 2px;
  padding-bottom: 2px;
}
.print {
  font-family: "Lucida Console", "Courier New", monospace;
}
</style>
<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" />

    <div class="row">
      <div class="col-lg-12">
        <div class="d-print-none">
          <div class="float-end">
            <a
              href="javascript:window.print()"
              class="btn btn-primary waves-effect waves-light me-1"
              ><i class="fa fa-print"></i> Print Invoice</a
            >
          </div>
        </div>
        <div class="d-print-none">
          <button @click="$router.go(-1)" class="btn btn-success mb-2">
            <i class="fas fa-arrow-circle-left"></i> Go Back
          </button>
          
        </div>
        <div class="bg-white p-2 print">
          <div class="invoice-title">
            <div style="width: 100%; top: 0px; height: 130px">
              <div style="width: 50%; float: left; top: 0px">
                <b-spinner
                  v-if="InsuranceInvoiceStatus"
                  class="m-0"
                  variant="primary"
                  role="status"
                ></b-spinner>
                <img
                  v-else
                  :src="
                    InsuranceCompanyInvoice.clinicLogo
                      ? InsuranceCompanyInvoice.clinicLogo
                      : '---'
                  "
                  alt="logo"
                  height="115px"
                />
              </div>

              <div style="width: 50%; float: right; top: 0px">
                <p
                  style="
                    text-transform: uppercase;
                    text-align: right;
                    font-size: 20px;
                    font-weight: bold;
                  "
                >
                  {{
                    InsuranceCompanyInvoice.clinicName
                      ? InsuranceCompanyInvoice.clinicName
                      : "-----"
                  }}
                </p>
                <table align="right" width="100%" style="font-size: 12px">
                  <tr align="right">
                    <td
                      v-html="
                        InsuranceCompanyInvoice.clinicAddress
                          ? InsuranceCompanyInvoice.clinicAddress
                          : '---'
                      "
                    ></td>
                  </tr>
                  <tr align="right">
                    <td>
                      <strong>Tel:</strong>
                      {{
                        InsuranceCompanyInvoice.clinicPhone
                          ? InsuranceCompanyInvoice.clinicPhone
                          : "---"
                      }}
                    </td>
                  </tr>
                  <tr align="right">
                    <td>

                      <strong>Email:</strong>
                      {{
                        InsuranceCompanyInvoice.company_email
                          ? InsuranceCompanyInvoice.company_email
                          : "---"
                      }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div class="invoice-title">
            <div style="width: 100%; top: 0px; height: 130px">
              <div style="width: 50%; float: left; top: 0px">
                <td width="50%">
                  <p style="margin: 5px">
                    Deliver to:
                    <b>{{
                      InsuranceCompanyInvoice.company_name
                        ? InsuranceCompanyInvoice.company_name
                        : "---"
                    }}</b>
                  </p>
                  <p style="margin: 5px">
                    Address:
                    <b>{{
                      InsuranceCompanyInvoice.company_address
                        ? InsuranceCompanyInvoice.company_address
                        : "---"
                    }}</b>
                  </p>
                  <p style="margin: 5px">
                    Contact:
                    <b>{{
                      InsuranceCompanyInvoice.company_phone
                        ? InsuranceCompanyInvoice.company_phone
                        : "---"
                    }}</b>
                  </p>
                  <p style="margin: 5px">
                    Email:
                    <b>{{
                      InsuranceCompanyInvoice.company_email
                        ? InsuranceCompanyInvoice.company_email
                        : "---"
                    }}</b>
                  </p>
                </td>
              </div>

              <div style="width: 50%; float: right; top: 0px">
                <td width="50%">
                  <p style="margin: 5px">
                    Date:
                    <b>{{ new Date().toLocaleString() }}</b>
                  </p>
                  <p style="margin: 5px">
                    Invoice No.:
                    <strong
                      >#{{
                        InsuranceCompanyInvoice.invoice_number
                          ? InsuranceCompanyInvoice.invoice_number
                          : "---"
                      }}</strong
                    >
                  </p>
                  <p style="margin: 5px">
                    Due Date:
                    <strong
                      >{{
                        InsuranceCompanyInvoice.due_date
                          ? InsuranceCompanyInvoice.due_date
                          : "---"
                      }}
                    </strong>
                  </p>
                </td>
              </div>
            </div>
          </div>

          <hr />
          <div class="row">
            <div class="col-12">
              <div class="p-2">
                <h3 class="font-size-16">PATIENTS</h3>
              </div>
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Service Details</th>
                 
                      <th>Total Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(patient, index) in InsuranceCompanyInvoice.all_patient
                        ? InsuranceCompanyInvoice.all_patient
                        : []"
                      :key="index"
                    >
                      <td>{{ patient.name }}</td>
                      <td>
                        <table class="table">
                          <tbody>
                            <tr v-for="(serv, index) in patient.services" :key="index">
                              <td>{{ serv.service }}</td>
                                <td>{{ serv.serv_date }}</td>
                              <td>{{ serv.cost }}  <div class="d-print-none">
          <div class="float-end">
          <i v-b-modal.edit_amount @click="setEditAmount(serv,'edit_amount')" class="fa fa-edit text-primary"></i>
          </div>
        </div></td>
                            
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td>{{ patient.amount }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="p-2">
                <h3 class="font-size-16">PAYMENT DETAILS</h3>
              </div>
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th>Total</th>
                      <th>Paid</th>
                      <th>Balance</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {{
                          InsuranceCompanyInvoice.total
                            ? InsuranceCompanyInvoice.total
                            : "---"
                        }}
                      </td>

                      <td>
                        {{
                          InsuranceCompanyInvoice.paid
                            ? InsuranceCompanyInvoice.paid
                            : "---"
                        }}
                      </td>
                      <td>
                        {{
                          InsuranceCompanyInvoice.balance
                            ? InsuranceCompanyInvoice.balance
                            : "---"
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="p-2">
                <h3 class="font-size-16">PAYMENT MODES</h3>
              </div>
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Provider</th>
                      <th>Account Number</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(mode, index) in PaymentModes" :key="index">
                      <td>{{ mode.modeName }}</td>
                      <td>{{ mode.provider }}</td>
                      <td>{{ mode.modeNumber ? mode.modeNumber : "--" }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <table width="100%">
              <tr>
                <center>
                  <p>Signature ..........................................</p>
                </center>
              </tr>
              <tr>
                <td>
                  <center>
                    Thank you for trusting
                    <strong>{{
                      InsuranceCompanyInvoice.clinicName
                        ? InsuranceCompanyInvoice.clinicName
                        : "---"
                    }}</strong>
                  </center>
                </td>
              </tr>
              <tr>
                <td>
                  <center>
                    For more inquiries call
                    <strong
                      >+{{
                        InsuranceCompanyInvoice.clinicPhone
                          ? InsuranceCompanyInvoice.clinicPhone
                          : "---"
                      }}</strong
                    >
                  </center>
                </td>
              </tr>

              <tr>
                <center>
                  <p>
                    Invoice Printed by
                    {{
                      InsuranceCompanyInvoice.printuser
                        ? InsuranceCompanyInvoice.printuser
                        : "---"
                    }}
                    via Clinic Plus Hospital Software
                  </p>
                </center>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  <b-modal 
  hide-footer 
  id="edit_amount" 
  size="sm" 
  :title="`EDIT ${edit_invoice.service} AMOUNT`"
  >
  <form>
  <div class="form-group">
  <input v-model="edit_invoice.cost" class="form-control" placeholder="Enter amount" />
  </div>
  <div class="modal-footer">
        <button   @click="closeMode('edit_amount')" type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Close</button>

        <button @click="editInvoiceAmount()" type="button" class="btn btn-primary btn-sm">Save  <b-spinner
                  v-if="InsuranceInvoiceStatus"
                  class="m-0"
                  small
                  variant="primary"
                  role="status"
                ></b-spinner> <i v-else class="fa fa-check"></i></button>
  </div>
  </form>
  </b-modal>
    <!-- end row -->
  </Layout>
</template>
